import "../../../css/AMLDasboard.css";
import StatusButton from "../../Components/Buttons/StatusButton";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import capitalizeFirst from "../../Checks/utils/factories/capitalise";
import { useUserRole } from "../../../context/UserRoleContext";
import { formatCheckType } from "../../CheckDetails/Utils/formatCheckType";
import { colorForResult } from "../../CheckDetails/Utils/getColorForDecision";

// import the reusable helper
import { computeOverallOutcome } from "../../CheckDetails/Utils/outcome/checkOutcome"; // <-- adjust path to wherever you saved it
import { getAllMatchesResolved } from "../../CheckDetails/Utils/Experian/allMatchesHaveReasons"; // needed for PEP reasons gate

export default function AMLTable({
  rows = [],
  onRowClick,
  currentPage = 1,
  pageSize = 5,
}) {
  const navigate = useNavigate();
  const { userRole } = useUserRole();
  // const { userPermissions } = useUserPermissions();

  const isAdmin =
    userRole === "Admin" ||
    userRole === "Super Admin" ||
    userRole === "Compliance Officer";
  // const canAccessExperian = canAccessAML(userPermissions);

  return (
    <div className="aml-table-wrap">
      <table className="aml-table">
        <thead>
          <tr>
            <th style={{ width: "10px" }}>
              <div className="AML-Text-Input"></div>
            </th>
            <th>
              <div className="AML-Text-Input">DETAILS</div>
            </th>
            <th>
              <div className="AML-Text-Input">STATUS</div>
            </th>
            <th>
              <div className="AML-Text-Input">RESULT</div>
            </th>
            <th>
              <div className="AML-Text-Input">EXPIRATION</div>
            </th>
            <th aria-label="ACTIONS" />
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: "center", padding: 24 }}>
                <div className="AML-Text-Body">
                  No results match your search.
                </div>
              </td>
            </tr>
          ) : (
            rows.map((r, i) => {
              const expiration = r.createdAt
                ? dayjs(r.createdAt).add(85, "day")
                : null;

              // compute once, reuse for both Status + Result
              const { checkStatus, checkResult } = computeOverallOutcome({
                rowOrCheck: r,
                checkType: r.checkType,
                experianResponse: r.experianResponse,
                reasonsByRef: r.reasonsByRef,
                getAllMatchesResolved,
              });

              const firstName =
                r?.decision?.verification?.person?.firstName || "";
              const lastName =
                r?.decision?.verification?.person?.lastName || "";
              const fullName = r.name || `${firstName} ${lastName}`.trim();

              const verifiedDob = r?.decision?.verification?.person?.dob;
              const dob = r.dob || verifiedDob || "";

              return (
                <tr
                  key={r.id || i}
                  className={`${onRowClick ? "is-clickable" : ""} ${
                    i % 2 === 0 ? "even" : "odd"
                  }`}
                  onClick={() =>
                    navigate("/check²/result", {
                      state: {
                        sessionId: r.sessionId || "",
                        vendorData:
                          r?.decision?.verification?.vendorData ||
                          r.vendorData ||
                          "",
                        forAdviser: r.forAdviser || "",
                        checkType: r.checkType || "",
                        createdBy: r.createdBy || "",
                        createdAt: r.createdAt || "",
                        name: fullName || "",
                        dob: dob || "",
                        fullAddress: r.fullAddress || "",
                        sessionUrl: r.sessionUrl || "",
                        expiration: expiration
                          ? expiration.format("DD MMM YYYY")
                          : "",
                        experianResponse: r.experianResponse || {},
                        reasonsByRef: r.reasonsByRef || {},
                      },
                    })
                  }
                >
                  <td>
                    <div className="AML-Text-Body">
                      {(currentPage - 1) * pageSize + i + 1}.
                    </div>
                  </td>

                  <td>
                    <div className="aml-user-info">
                      <div className="AML-Text-Input">{fullName}</div>

                      {/* {isAdmin && ( */}
                      <div className="hide AML-Text-Body">
                        Requested By: {r.createdBy || ""}
                      </div>
                      {/* )} */}

                      {r.forAdviser && (
                        <div className="hide AML-Text-Body">
                          Requested On Behalf Of: {r.forAdviser}
                        </div>
                      )}

                      <div className="hide AML-Text-Body">
                        Date Run:{" "}
                        {r.createdAt
                          ? dayjs(r.createdAt).format("DD MMM YYYY")
                          : "-"}
                      </div>

                      <div className="hide AML-Text-Body">
                        Check Type: {formatCheckType(r.checkType)}
                      </div>
                    </div>
                  </td>

                  <td>
                    <StatusButton
                      type={capitalizeFirst(checkStatus)}
                      color={colorForResult(checkStatus)}
                    />
                  </td>

                  <td>
                    {checkResult ? (
                      <StatusButton
                        type={capitalizeFirst(checkResult)}
                        color={colorForResult(checkResult)}
                      />
                    ) : null}
                  </td>

                  <td className="AML-Text-Body" style={{ color: "black" }}>
                    {expiration ? expiration.format("DD MMM YYYY") : "-"}
                  </td>

                  <td>
                    <div className="aml-row-icon">
                      <ArrowRight />
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
